import { FC, ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { Navigate, useLocation, useParams } from 'react-router-dom'

import { Box } from '@mui/material'

import GRTabNavigation from '../../../components/GRTabNavigation/GRTabNavigation'
import usePage from '../../../hooks/usePage'
import pageService from '../../../services/PageService'
import { ModulesTab } from '../../features/plans/components/ModulesTab/ModulesTab'
import { PackagesTab } from '../../features/plans/components/PackagesTab/PackagesTab'
import { RolesTab } from '../../features/plans/components/RolesTab/RolesTab'
import { PlanTab } from '../../features/plans/components/helpers/planHelpers'

const planTabs: { id: PlanTab; nameKey: string; content: ReactNode }[] = [
  { id: 'packages', nameKey: 'internal-csm:plans_tab_packages', content: <PackagesTab /> },
  { id: 'roles', nameKey: 'internal-csm:plans_tab_roles', content: <RolesTab /> },
  { id: 'modules', nameKey: 'internal-csm:plans_tab_modules', content: <ModulesTab /> },
]

export const PlansPage: FC = () => {
  usePage(pageService.getInternalPageWithId('internal-plans'))
  const { t } = useTranslation()
  const { tab } = useParams<{ tab?: string }>()
  const location = useLocation()
  const selectedIndex = planTabs.findIndex((candidate) => candidate.id === tab)

  if (selectedIndex < 0) return <Navigate to={`/internal/plans/${planTabs[0].id}`} replace />

  return (
    <Box>
      <GRTabNavigation
        tabs={planTabs.map(({ id, nameKey }) => ({ id, name: t(nameKey) }))}
        selectedTab={selectedIndex}
        pagePrefix="/internal/plans"
        query={location.search}
        sticky={false}
      />
      {planTabs[selectedIndex].content}
    </Box>
  )
}
